import { HookOutOfContextError } from "@jugl-web/utils";
import { useContext } from "react";
import { CPanelPageContext } from "./CPanelPageContext";

export const useCPanelPageContext = () => {
  const context = useContext(CPanelPageContext);

  if (!context) {
    throw new HookOutOfContextError(
      "useCPanelPageContext",
      "CPanelPageContext"
    );
  }

  return context;
};
